(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pil-austin-cro"] && !Shopify.designMode) return;
  try {
    const initialisePilAustinCro = () => {
    document.querySelectorAll('[data-pil-austin-cro]').forEach((root) => {
      if (root.dataset.initialised === 'true') return;

      const productInfo = root.closest('product-info');
      if (!productInfo) return;

      const details = productInfo.querySelector('.product__details');
      const title = details?.querySelector('.product__title');
      const announcement = document.querySelector('.announcement-bar__text');
      const announcementSource = root.querySelector('[data-pil-announcement]');
      const titleSource = root.querySelector('[data-pil-title]');
      const rating = details?.querySelector('.shopify-app-block');
      const stock = details?.querySelector('.product__liquid');
      const dealerBadge = details?.querySelector('.authorized-dealer-badge');
      const bestFor = root.querySelector('[data-pil-best-for]');
      const shipping = root.querySelector('[data-pil-shipping]');
      const help = root.querySelector('[data-pil-help]');
      const priceTax = details?.querySelector('.product__tax');
      const productForm = details?.querySelector('product-form');
      const share = productInfo.querySelector('.product__share');
      const complementary = productInfo.querySelector('product-complementary');
      const productSection = productInfo.closest('.shopify-section');
      const educationSection = productSection?.nextElementSibling;

      if (announcement && announcementSource) announcement.textContent = announcementSource.textContent.trim();
      if (title && titleSource) title.textContent = titleSource.textContent.trim();
      if (title && rating) title.insertAdjacentElement('afterend', rating);

      if (bestFor) {
        bestFor.hidden = false;
        const bestForAnchor = stock || dealerBadge || title;
        bestForAnchor?.insertAdjacentElement('afterend', bestFor);
      }

      if (shipping && priceTax) {
        shipping.hidden = false;
        priceTax.replaceWith(shipping);
      }

      if (help && productForm) {
        help.hidden = false;
        productForm.insertAdjacentElement('afterend', help);
      }

      if (share) share.hidden = true;

      if (complementary && educationSection) {
        complementary.classList.add('pil-austin-cro__complementary');
        educationSection.insertAdjacentElement('beforeend', complementary);
      }

      root.dataset.initialised = 'true';

      const compactChat = () => {
        const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
        if (!chatRoot) return false;
        if (chatRoot.querySelector('#pil-austin-cro-chat')) return true;

        const chatStyle = document.createElement('style');
        chatStyle.id = 'pil-austin-cro-chat';
        chatStyle.textContent = '.activator{width:46px!important;min-width:46px!important;padding-left:0!important;padding-right:0!important;justify-content:center!important}.activator__label{display:none!important}';
        chatRoot.appendChild(chatStyle);
        return true;
      };

      if (!compactChat()) {
        let chatAttempts = 0;
        const chatTimer = window.setInterval(() => {
          chatAttempts += 1;
          if (compactChat() || chatAttempts >= 20) window.clearInterval(chatTimer);
        }, 250);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePilAustinCro);
  } else {
    initialisePilAustinCro();
  }

  document.addEventListener('shopify:section:load', initialisePilAustinCro);
  } catch(e) { console.error(e); }
})();

})();
